// Zamiana parametrów Refine na nasz kontrakt listy: limit/offset/sort/order
// plus jawne filtry. Wydzielone z providera, bo to czysta funkcja i jako taka
// da się ją przetestować bez sieci.

import type { CrudFilter, CrudSort, Pagination } from "@refinedev/core";

export interface ListQueryInput {
  pagination?: Pagination;
  sorters?: CrudSort[];
  filters?: CrudFilter[];
}

export const DEFAULT_PAGE_SIZE = 25;

/**
 * Backend przyjmuje offset, a Refine liczy strony od 1. Pomyłka o jeden
 * objawia się tym, że pierwsza strona gubi pierwszy wiersz.
 */
export function buildListQuery(input: ListQueryInput): URLSearchParams {
  const params = new URLSearchParams();

  const page = input.pagination?.currentPage ?? 1;
  const pageSize = input.pagination?.pageSize ?? DEFAULT_PAGE_SIZE;
  params.set("limit", String(pageSize));
  params.set("offset", String(Math.max(0, (page - 1) * pageSize)));

  const sorter = input.sorters?.[0];
  if (sorter) {
    params.set("sort", sorter.field);
    params.set("order", sorter.order);
  }

  for (const filter of input.filters ?? []) {
    // Filtry złożone (and/or) nie mają odpowiednika w naszym API i cicho je
    // pomijamy - lepiej pokazać za dużo wierszy niż udawać, że filtr zadziałał.
    if (!("field" in filter)) continue;
    if (filter.operator !== "eq") continue;
    if (filter.value === undefined || filter.value === null || filter.value === "") continue;
    params.set(filter.field, String(filter.value));
  }

  return params;
}

/**
 * Bieżąca wartość filtru do wpięcia w pole formularza. Nazwa filtru w Refine
 * i nazwa parametru w API są te same, więc nie ma tu żadnego mapowania.
 *
 * Rozróżnienie "brak wartości" od `false` jest istotne: filtry logiczne
 * (aktywne pytanie, wstrzymany harmonogram, zablokowane konto) mają trzy
 * stany, a skrót przez `? :` zlałby "nie" z "wszystkie".
 */
export function filterValue(filters: { field?: string; value?: unknown }[], field: string): string {
  const found = filters.find((filter) => filter.field === field);
  if (found?.value === undefined || found?.value === null) return "";
  return String(found.value);
}
